import { useActiveOrganization } from "@hooks/useActiveOrganization";
import { useUser } from "@hooks/useUser";

export function useActiveOrganizationAssignment() {
    const activeOrganization = useActiveOrganization();
    const user = useUser();

    if (!activeOrganization || !user) {
        return null;
    }

    return activeOrganization.userAssignments?.find(
        (ua) => ua.userId === user.id,
    );
}
